
<div class="page-header">
    <a routerLink="/activiteit-locaties/overzicht" class="page-header__back">
        <i class="fa-regular fa-chevron-left"></i>
    </a>
    <h1 class="page-header__title">{{ "activity-locations.title" | translate }}</h1>
    <div class="page-header__actions"></div>
</div>

<app-activity-location-detail-form [activityLocation]="activityLocation$ | async" (submitted)="submit($event)" [errors]="errors$ | async" [loading]="loading$ | async"/>